import { render, staticRenderFns } from "./Bloco1Navbar.vue?vue&type=template&id=da29d590&scoped=true&"
import script from "./Bloco1Navbar.vue?vue&type=script&lang=js&"
export * from "./Bloco1Navbar.vue?vue&type=script&lang=js&"
import style0 from "./Bloco1Navbar.vue?vue&type=style&index=0&id=da29d590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da29d590",
  null
  
)

export default component.exports